<template>
  <div class="backdrop" @keydown.esc="escapePressed">
    <div class="modal-container" :class="type">
      <close-button @click="abort" v-if="closeable"/>
      <div class="modal-wrapper">
        <div class="content-wrapper">
          <slot></slot>
        </div>
        <div class="abort-wrapper mt-1" v-if="closeable && false">
          <outline-button :border="true" :dark="is_it_dark" @click.prevent="abort">{{$t('buttons.close')}}</outline-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OutlineButton from '@/components/buttons/OutlineButton.vue'
import CloseButton from "./CloseButton";

export default {
  props: {
    closeable: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'light'
    }
  },
  computed: {
    is_it_dark(){
      if(this.type == 'dark')
        return true
      else
        return false
    }
  },
  methods: {
    escapePressed() {
      if (this.closeable) {
        this.abort()
      }
    },
    abort () {
      this.$emit('abort')
    }
  },
  components: {
    CloseButton,
    OutlineButton
  }
}
</script>

<style lang="scss">
  .backdrop {
    background: rgba(0, 0, 0, 0.8);
    align-items: flex-start;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 2rem;
    z-index: 9000;

    @media screen and (max-width: 769px) {
      padding: 0;
    }
    &.no-padding > .modal-container > .modal-wrapper > .content-wrapper {
      padding: 0;
    }
  }

  .modal-container {
    width: 745px;
    max-width: 100%;
    min-height: 300px;
    padding: 0;
    background-color: $body-bg;
    display: flex;
    position: relative;
    @media screen and (max-width: 769px) {
      padding-bottom: 75px;
      width: 100%;
    }

    .content-wrapper {
      padding: 30px 30px 15px;
      @media screen and (max-width: 750px) {
        padding: 20px 20px 5px;
        h3 {
          margin-right: 30px;
        }
      }
    }

    .abort-wrapper {
      text-align: center;
    }


    &.dark {

      background-color: $dark-bg;
      .grey-block {
        padding: 0 30px 15px;
      }
      @media screen and (max-width: 769px) {
        display: block;
        .text-wrapper {
          padding-left: 30px;
          padding-right: 30px;
        }
        padding-bottom: 50px;
      }
    }
  }
  .modal-wrapper {
    flex: 1;
    padding-bottom: 15px;
    @media screen and (max-width: 769px) {
      min-height: 100vh;
      padding-bottom: 150px;
    }
  }
</style>
